module.exports = __webpack_public_path__ + "img/Steve.08c3ca33.png";